<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="changeResult"
          :value.sync="queryParams.changeResult"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'MES_APPROVAL_EXECUTE_RESULT' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiMaterialChangeExport" ref="download" />
        <a-button type="primary" @click="handleExport" v-hasPermi="['mes:wipChangeItemRecord:export']">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
            density: true, // 传入String时 初始化默认表格密度
            fullScreen: false, // 是否需要全屏
            configKey: $TableKey.MATERIAL_CHANGE_REPORT_LIST, // 表格方案配置唯一值
          }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiMaterialChangeList, apiMaterialChangeExport } from '@/api/report/material-change-report'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Material-change-report', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      apiMaterialChangeExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMaterialChangeList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        wipEntityName: undefined,
        itemCode: undefined,
        changedItemCode: undefined,
        remarks: undefined,
        changeResult: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '工单号',
          decorator: ['wipEntityName'],
          type: 'input'
        },
        {
          label: '变更前物料编码',
          decorator: ['itemCode'],
          type: 'input'
        },
        {
          label: '变更后物料编码',
          decorator: ['changedItemCode'],
          type: 'input'
        },
        {
          label: '备注',
          decorator: ['remarks'],
          type: 'input'
        },
        {
          label: '变更结果',
          decorator: ['changeResult'],
          type: 'changeResult'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: 'BOM用量',
          dataIndex: 'quantityPerAssembly',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '变更后物料编码',
          dataIndex: 'changedItemCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '变更后物料名称',
          dataIndex: 'changedItemName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '变更后规格描述',
          dataIndex: 'changedSpecification',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '变更后用量',
          dataIndex: 'changedQuantityPerAssembly',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '变更原因',
          dataIndex: 'changeReason',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '变更结果',
          dataIndex: 'changeResultName',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '库存组织',
          dataIndex: 'desOrganizationName',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '单号',
          dataIndex: 'billNo',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '申请人',
          dataIndex: 'applicant',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '申请时间',
          dataIndex: 'applyTime',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '审批状态',
          dataIndex: 'statusName',
          align: 'center',
          width: 100,
          ellipsis: true
        }
      ]
    }
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        wipEntityName: undefined,
        itemCode: undefined,
        changedItemCode: undefined,
        remarks: undefined,
        changeResult: undefined
      }
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
